import React from 'react';
import '../styles/Loading.css';
import loading from "../assets/loading.svg";

const Loading = () => {
  return (
    <div className="loading-container admin-loading-shell">
      <div className="admin-loading-card">
        <div className="spinner">
          <img src={loading} alt="Loading" />
        </div>
        <div className="admin-loading-text">
          <strong>Yönetim paneli hazırlanıyor</strong>
          <span>İşletme verileri ve yetkiler yükleniyor.</span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
